<template>
  <div class="p-6">
    <v-toolbar class="page-title" elevation="0">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="goHome()" class="mr-3" v-on="on" tile small>
            <v-icon left>fa fa-chevron-left</v-icon>
            Dashboard
          </v-btn>
        </template>
        <span> Go back </span>
      </v-tooltip>
      <v-btn
        small
        class="mr-4"
        @click="createAuthorDialog = true"
        color="primary"
      >
        <v-icon class="mr-1" dark>fa fa-plus</v-icon>
        Create New author
      </v-btn>
      <slot name="actions"> </slot>
    </v-toolbar>
    <v-container>
      <div class="search-wrapper">
        <v-text-field
          v-model="search"
          label="Search..."
          prepend-inner-icon="fa fa-search"
          single-line
          outlined
          hide-details
          dense
        >
        </v-text-field>
        <small>
          Showing {{ searchResultsCount }} vegetables out of
          {{ authors.length }}.
        </small>
      </div>
      <v-data-table
        v-model="selectedAuthor"
        :headers="headers"
        :items="authors"
        :search="search"
        item-key="name"
        class="elevation-1"
        @current-items="getFiltered"
      >
        <template v-slot:item.Actions="{ item }">
          <td>
            <v-icon small class="mr-2" @click="viewAuthor(item)">
              fa fa-eye
            </v-icon>
            <v-icon v-if="userIsAdmin == 'true'" small class="mr-2" @click="editAuthor(item)">
              fa fa-clone
            </v-icon>
            <v-icon v-if="userIsAdmin == 'true'" color="red" small @click="deleteAuthor(item)">
              fa fa-trash
            </v-icon>
          </td>
        </template>
      </v-data-table>
    </v-container>
    <CreateModal
      @create-modal-visibility="changeModalVisibility()"
      v-if="createAuthorDialog"
      :create-dialog="createAuthorDialog"
      :modal-title="'Create  Author'"
    ></CreateModal>
    <CreateModal
      @create-modal-visibility="changeEditModalVisibility()"
      :first-name="authorFirstName"
      :last-name="authorLastName"
      :id="id"
      v-if="editAuthorDialog"
      :create-dialog="editAuthorDialog"
      :modal-title="'Edit author'"
    ></CreateModal>
    <v-snackbar v-model="snackbar" :timeout="5000">
      {{ "Sucessfully deleted! " }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import * as API from "./../../api";

const CreateModal = () => import("./CreateDialog");

export default {
  name: "authors",
  components: { CreateModal },
  methods: {
    getauthors() {
      this.$api
        .get(API.endpoints.authors)
        .then((response) => {
          this.authors = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    viewAuthor(item) {
      this.$router.push({ path: "authors/" + item.ID });
    },
    getFiltered(filtered) {
      this.searchResultsCount = filtered.length;
    },
    editAuthor(item) {
      this.authorFirstName = item.FirstName;
      this.authorLastName = item.LastName;
      this.id = item.ID;
      this.editAuthorDialog = !this.editAuthorDialog;
    },

    deleteAuthor(item) {
      this.$api
        .delete(API.endpoints.authors + "/" + item.ID)
        .then(() => {
          this.snackbar = true;
        })
        .catch(() => {
          console.log("Error deleting");
        });
    },

    changeEditModalVisibility() {
      this.editAuthorDialog = !this.editAuthorDialog;
    },
    changeModalVisibility() {
      this.createAuthorDialog = !this.createAuthorDialog;
    },

    goHome() {
      this.$router.push("/");
    },
  },
  data() {
    return {
      userIsAdmin: localStorage.getItem("userIsAdmin"),
      selectedAuthor: {},
      search: "",
      createAuthorDialog: false,
      editAuthorDialog: false,
      authorFirstName: "",
      authorLastName: "",
      headers: [
        { text: "Id", value: "ID", align: "center" },
        { text: "First Name", value: "FirstName", align: "center" },
        { text: "Last Name", value: "LastName", align: "center" },
        { text: "Actions", value: "Actions" },
      ],
      authors: [],
      searchResultsCount: 0,
      snackbar: false,
    };
  },
  mounted() {
    this.getauthors();
    console.log('useradmi' +         this.userIsAdmin)
  },
};
</script>

<style scoped>
.page-title {
  border-bottom: 1px solid rgba(219, 219, 219, 0.48);
  font-size: 15px;
}
</style>
